<template>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>
          <span>Urgent Shift</span>
       
      </ion-title>
      <ion-buttons slot="end">
        <ion-button @click="share()">
          <i class="el-icon-share"></i>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <div v-if="shifts.length === 0" class="search_jobs_header-outer">
       
       <div class="search_jobs_header search_jobs_header--custom">

        <div class="search_jobs_header-top">
          <img :src="require(`@/assets/img/illustrations/unavailable.svg`)" alt=""  class="urgent-taken"/>
          <div class="main_title text-center"><i class="el-icon-warning"></i> Shift has been taken!</div>
        </div>
      
         <el-button class="w100" :type="'blue'" @click="close()">
           Click here to browse more shifts
         </el-button>
       </div>
     </div>
      <div v-else class="main_wrapper ion-padding">
        <div class="container">

          <div class="job_info_wrapper" v-if="job.pharmacy">
            <div class="image_text_comp d-block" @click="userInfoModalOpen()">
              <div class="image_wrapper">
                <el-avatar
                  :size="'medium'"
                  shape="square"
                  :src="job.pharmacy.image"
                  v-if="job.pharmacy.image"
                />
                <el-avatar
                  :size="'small'"
                  shape="square"
                  icon="el-icon-user-solid"
                  v-else
                ></el-avatar>
              </div>
              <div class="text_wrapper mt-2">
                <div class="main_text">{{ job.pharmacy.name }}</div>
                <div class="additional_text">
                  <span class="distance">
                    <span class="locumate_icons locumate_icon-cursor"></span>
                    <span v-if="job.distance">{{ job.distance }} km</span>
                    <span class="symb_infinity" v-else></span>
                    <span class="symb_dot"></span>
                  </span>
      
                  <span>{{ $filters.addressText(job.pharmacy.address) }}</span>
                </div>
              </div>
            </div>
            <div class="info-separator"></div>
            <div class="rate_shifts_info">
              <div class="info_wrapper d-flex align-items-center gap-2" v-if="showJobRateSummary">
                <DollarWithCircleIcon />
                <div class="info_title">Hourly rate (excluding super)</div>
                <div class="info_value">
                  {{
                    formatHourlyRate(job.recommendedRate, job.recommendedWeekendRate)
                  }}
                </div>
              </div>
              <!-- <div class="info_wrapper">
                <div class="info_title">Available shifts</div>
                <div class="info_value">
                  <template v-if="checkJobDateStart(job.startDate, job.endDate)">
                    <span>{{ checkJobDateStart(job.startDate, job.endDate) }}</span> -
                  </template>
                  <span>{{
                    $moment(job.endDate, "YYYY/MM/DD").format("D MMMM")
                  }}</span>
                </div>
              </div> -->
            </div>
            <div class="info-separator mb-0"></div>
            <el-collapse accordion class="job-about-collapse" @change="handleChange">
              <el-collapse-item
                class="card-accordeon"
                title="More about the job"
                name="first"
              >
                <div class="collapse-list more-info">
                  <div class="collapse-item" v-if="showJobRateSummary">
                    <span class="collapse-title">Hourly Rate (excluding super)</span>
                    <span class="collapse-value">
                      {{
                        formatHourlyRate(
                          job.recommendedRate,
                          job.recommendedWeekendRate
                        )
                      }}</span
                    >
                  </div>
                  <div v-if="job.settings.language" class="collapse-item">
                    <span class="collapse-title">Language</span>
                    <span class="collapse-value">{{ job.settings.language }}</span>
                  </div>
      
                  <div class="collapse-item">
                    <span class="collapse-title">Solo Pharmacist</span>
                    <span class="collapse-value">{{
                      job.settings.solo == 1 ? "Yes" : "No"
                    }}</span>
                  </div>
      
                  <div class="collapse-item">
                    <span class="collapse-title"> "Covid" {{ message.Immuniser }} req?</span>
                    <span class="collapse-value">{{
                      job.covidCertRequired == 0
                        ? "Not Required"
                        : job.covidCertRequired == 1
                        ? "Mandatory"
                        : "Nice to Have"
                    }}</span>
                  </div>
      
                  <div class="collapse-item">
                    <span class="collapse-title">Number of technicians</span>
                    <span class="collapse-value">{{ job.settings.numOfTech }}</span>
                  </div>
      
                  <div class="collapse-item" v-if="job.settings.payingForTravel == 3 && job.maxTravelCompensation !== 0">
                    <span class="collapse-title">Pay for Travel</span>
                    <span class="collapse-value">Capped Travel</span>
                  </div>
                  <div class="collapse-item" v-else>
                    <span class="collapse-title">Pay for Travel {{
                      job.settings.payingForTravel == 1 ? " (>50KM roundtrip)" : ""
                    }}</span>
                    <span class="collapse-value">{{
                      job.settings.payingForTravel == 0
                      ? "No travel"
                      : job.settings.payingForTravel == 1
                        ? "Partial travel"
                        : "Full travel"
                    }}</span>
                  </div>
                  <div class="collapse-item">
                    <span class="collapse-title">Pay for Flights</span>
                    <span class="collapse-value">{{
                      job.settings.payForFlights == 0 ? "No" : "Yes"
                    }}</span>
                  </div>
                  <div class="collapse-item">
                    <span class="collapse-title">Pay for Accommodation</span>
                    <span class="collapse-value">{{
                      job.settings.payForAccommodation == 0 ? "No" : "Yes"
                    }}</span>
                  </div>
                  <div class="collapse-item" v-if="isAustralia">
                    <span class="collapse-title">Dosage Administration Aids</span>
                    <span class="collapse-value">{{
                      job.settings.adminAids == 1 ? "Yes" : "No"
                    }}</span>
                  </div>
                  <div class="collapse-item">
                    <span class="collapse-title">Open Pharmacy</span>
                    <span class="collapse-value">{{
                      job.settings.openUp == 1 ? "Yes" : "No"
                    }}</span>
                  </div>
                  <div class="collapse-item">
                    <span class="collapse-title">Close Pharmacy</span>
                    <span class="collapse-value">{{
                      job.settings.close == 1 ? "Yes" : "No"
                    }}</span>
                  </div>
                  <div v-if="job.settings.notes" class="collapse-item collapse-item--notes">
                    <span class="collapse-title">Notes</span>
                    <p class="job-notes__content">{{ job.settings.notes }}</p>
                  </div>
                  <div v-if="job.settings.parking" class="collapse-item collapse-item--notes">
                    <span class="collapse-title">Parking</span>
                    <p class="job-notes__content">{{ job.settings.parking }}</p>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <div class="info-separator mt-0"></div>
          </div>
      
          <div>
            <el-form
            class="job_shifts_wrapper full_page"
            :model="formsData.dayForm"
            :rules="formsData.dayForm.rules"
            :ref="(el) => (formsData.dayForm.ref = el)"
            :label-position="'top'"
            @submit.prevent="submit('dayForm')"
          >
            <div
              class="form_text"
              v-if="formsData.dayForm.jobShifts.value.length >= 2"
            >
              <div class="text_note">Deselect days you do not wish to work</div>
            </div>
            <div
              class="job_shifts_form_checkbox"
              v-for="(shift, i) in formsData.dayForm.jobShifts.value"
              :key="shift.date"
            >
           
            <div v-if="shift.disabled==true">
                
                <i class="el-icon-warning"></i>Conflict with shift
            </div>
              <el-form-item class="mb0" prop="jobShifts">
                <el-checkbox
                  :disabled="shift.disabled"
                  class="checkbox_w100"
                  v-model="shift.checkboxValue"
                  @change="checkboxValueChange"
                >
                  <div
                    :class="shift.confirmedHours ? 'confirmedHours' : ''"
                    class="job_shift_text"
                  >
                    <div class="day_info">
                      <div class="day_name">
                        {{ $moment(shift.date, "YYYY/MM/DD").format("ddd") }},
                        {{ $moment(shift.date, "YYYY/MM/DD").format("D MMM, YYYY") }}
                      </div>
                      <div class="day_time">
                        <span>{{
                          $moment(shift.startTime, "HH:mm").format("h:mm A")
                        }}</span>
                        -
                        <span>{{
                          $moment(shift.endTime, "HH:mm").format("h:mm A")
                        }}</span>
                      </div>
                    </div>
                    <div class="info-wrapper">
                      <div class="day_info_block" v-if="showShiftRateBlock(shift)">
                        <DollarWithCircleIcon />
                        <div class="day_name">Rate</div>
                        <div class="day_time">
                          <span v-if="showShiftInformation(shift)">
                            {{ Rate(shift) }}</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="day_info_block">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.3333 10C18.3333 14.6 14.6 18.3333 10 18.3333C5.4 18.3333 1.66667 14.6 1.66667 10C1.66667 5.40001 5.4 1.66667 10 1.66667C14.6 1.66667 18.3333 5.40001 18.3333 10Z"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13.0917 12.65L10.5083 11.1083C10.0583 10.8417 9.69167 10.2 9.69167 9.675V6.25833"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div class="day_name">Hours</div>
                        <div class="day_time">
                          <span v-if="showShiftInformation(shift)">
                            {{
                              confirmedHours(
                                shift.confirmedHours,
                                shift.startTime,
                                shift.endTime
                              )
                            }}</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="day_info_block">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.72501 3.83334C2.39167 0.950004 6.73334 0.950004 7.39167 3.83334C7.78334 5.525 6.70834 6.95834 5.77501 7.85C5.09167 8.5 4.01667 8.49167 3.33334 7.85C2.40834 6.95834 1.33334 5.525 1.72501 3.83334Z"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                          />
                          <path
                            d="M12.5583 13.8333C13.225 10.95 17.5917 10.95 18.2583 13.8333C18.65 15.525 17.575 16.9583 16.6333 17.85C15.95 18.5 14.8667 18.4917 14.1833 17.85C13.2417 16.9583 12.1667 15.525 12.5583 13.8333Z"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                          />
                          <path
                            d="M9.99997 4.16699H12.2333C13.775 4.16699 14.4916 6.07533 13.3333 7.09199L6.67497 12.917C5.51664 13.9253 6.23331 15.8337 7.76664 15.8337H9.99997"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.57185 4.58366H4.58148"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.4052 14.5837H15.4148"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div class="day_name">Travel</div>
                        <div class="day_time">
                          <span v-if="showShiftInformation(shift)">
                            {{ travelCompensationCount(job, shift) }}
                          </span>
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="day_info_block" v-if="showShiftRateBlock(shift)">
                        <DollarWithCircleIcon />
                        <div class="day_name">Sum</div>
                        <div class="day_time">
                          <span v-if="showShiftInformation(shift)">
                            {{ Sum(shift) }}</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-checkbox>
                <template #error="{ error }">
                  <div
                    class="error_list"
                    v-if="
                      error ||
                      (formsData.dayForm.jobShifts.errors &&
                        formsData.dayForm.jobShifts.errors[i])
                    "
                  >
                    <div
                      class="el-form-item__error"
                      :class="
                        formsData.dayForm.jobShifts.errors &&
                        formsData.dayForm.jobShifts.errors[i]
                          ? ''
                          : 'form_error'
                      "
                    >
                      <span
                        v-if="
                          error &&
                          !formsData.dayForm.jobShifts.errors &&
                          formsData.dayForm.jobShifts.value.length - 1 == i
                        "
                        >{{ error }}</span
                      >
                      <span
                        v-if="
                          formsData.dayForm.jobShifts.errors &&
                          formsData.dayForm.jobShifts.errors[i]
                        "
                        >{{ formsData.dayForm.jobShifts.errors[i].message }}</span
                      >
                    </div>
                  </div>
                  <span v-else></span>
                </template>
              </el-form-item>
            </div>
            <el-form-item prop="jobShiftsErrors" class="button_submit mb0">
              <el-button class="submit_page" type="grey" @click="goNext('dayForm')">
                Calendar View
              </el-button>
               <el-button
                class="submit_page"
                type="blue"
                @click="dialogVisible = true"
                :disabled="formsData.dayForm.disabled"
                v-if="job.applyJob"
              >
                Apply now
              </el-button>
              <el-button
                class="submit_page"
                type="blue"
                @click="dialogVisible = true"
                :disabled="formsData.dayForm.disabled" v-else
              >
                Accept
              </el-button>
            </el-form-item>
          </el-form>
          </div>
        </div>
      
    <div class="el_dialog_wraper">
      <el-drawer
        v-model="dialogVisible"
        custom-class="bottom_drop_up accept_shift"
        title="Please ensure you have checked your availability for selected shift(s). Any cancellations will impact your reliability rating on the platform. "
        width="30%"
        :append-to-body="true" :with-header="false" :direction="'btt'" :destroy-on-close="true" data-testid="more-bottom-drop-up-drawer"
      >
        <div class="title-wrapper text-center">
          <div class="title text-locumate-secondary">Are you sure!</div>
          <p class="message">
            Please ensure you have checked your availability for selected shift(s). Any cancellations will impact your reliability rating on the platform.  
          </p>
        </div>
        <div
          class="job_shifts_form_checkbox"
          v-for="shift in formsData.dayForm.jobShifts.value"
          :key="shift.date"
        >
          <div
            class="job_shifts_wrapper full_page"
            v-if="shift.checkboxValue == true"
          >
            <div class="mb0 shift-check" prop="jobShifts">
              <div
                :class="shift.confirmedHours ? 'confirmedHours' : ''"
                class="job_shift_text"
              >
              <div class="check-icon"><i class="el-icon-check"></i></div>
                <div class="">
                  <div class="check-outer">
                    <!-- <span><i class="el-icon-check"></i></span> -->
                    <div class="check-inner day_info">
                      <div class="day_name day_name-bold">
                        {{ $moment(shift.date, "YYYY/MM/DD").format("ddd") }},
                        {{
                          $moment(shift.date, "YYYY/MM/DD").format("D MMM, YYYY")
                        }}
                      </div>
                      <div class="day_time">
                        <span>{{
                          $moment(shift.startTime, "HH:mm").format("h:mm A")
                        }}</span>
                        -
                        <span>{{
                          $moment(shift.endTime, "HH:mm").format("h:mm A")
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="info-wrapper">
                  <div class="day_info_block" v-if="showShiftRateBlock(shift)">
                    <DollarWithCircleIcon />
                    <div class="day_name day_name-bold">Rate</div>
                    <div class="day_time">
                      <span v-if="showShiftInformation(shift)">
                        {{ Rate(shift) }}</span
                      >
                      <span v-else>-</span>
                    </div>
                  </div>
                  <div class="day_info_block">
                    <ClockIcon />
                    <div class="day_name day_name-bold">Hours</div>
                    <div class="day_time">
                      <span v-if="showShiftInformation(shift)">
                        {{
                          confirmedHours(
                            shift.confirmedHours,
                            shift.startTime,
                            shift.endTime
                          )
                        }}</span
                      >
                      <span v-else>-</span>
                    </div>
                  </div>
                  <div class="day_info_block">
                    <RoutingIcon />
                    <div class="day_name day_name-bold">Travel</div>
                    <div class="day_time">
                      <span v-if="showShiftInformation(shift)">
                        {{ travelCompensationCount(job, shift) }}
                      </span>
                      <span v-else>-</span>
                    </div>
                  </div>
                  <div class="day_info_block" v-if="showShiftRateBlock(shift)">
                    <DollarWithCircleIcon />
                    <div class="day_name day_name-bold">Sum</div>
                    <div class="day_time">
                      <span v-if="showShiftInformation(shift)">
                        {{ Sum(shift) }}</span
                      >
                      <span v-else>-</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dialog-footer">
            <el-button
              class="submit_page mb-3"
              type="blue"
              :disabled="formsData.dayForm.disabled"
              v-if="job.applyJob"
              @click="applyShift('dayForm', job.id)"
            >
              Apply now
            </el-button>
            <el-button
              class="submit_page mb-3"
              type="blue"
              @click="submit('dayForm')"
              :disabled="formsData.dayForm.disabled"
              v-else
            >
              Accept shift(s)
            </el-button>
            
          <el-button class="el-button--grey" :type="gray" @click="dialogVisible = false">Cancel</el-button>
        </div>
  
        <!-- <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">Cancel</el-button>
            <el-button
              class="submit_page"
              type="blue"
              :disabled="formsData.dayForm.disabled"
              v-if="job.applyJob"
              @click="applyShift('dayForm', job.id)"
            >
              Apply now
            </el-button>
            <el-button
              class="submit_page"
              type="blue"
              @click="submit('dayForm')"
              :disabled="formsData.dayForm.disabled"
              v-else
            >
              Accept shift(s)
            </el-button>
          </span>
        </template> -->
      </el-drawer>
    </div>
     </div>
   
  
    <modal-user-info
      :modalName="'userInfoModal'"
      :options="userInfoModal"
    ></modal-user-info>
  </template>
  
  <script>
  import { ElMessage } from "@/components/Vendor/Element";
  
  import moment from "moment";
  
  import { ref, onBeforeMount, onMounted, inject, nextTick, computed } from "vue";
  
  import { addIcons } from "ionicons";
  import { arrowBackOutline } from "ionicons/icons";
  
  addIcons({
    "arrow-back-outline": arrowBackOutline,
  });
  import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
  } from "@ionic/vue";
  
  import { useStore } from "vuex";
  import { useRoute, useRouter } from "vue-router";
  import formHooks from "@/hooks/form/form";
  import formValidate from "@/hooks/form/validate/validate";
  
  import { UserInfoModal } from "@/modals/modals";
  import timeDiff from "@/helpers/date/timeDiff";
  import timeDiffAsDecimal from "@/helpers/date/timeDiffAsDecimal";
  import { locumCanSeeShiftRates, locumCanSeeJobRates } from "@/helpers/utility/locumShiftRates";
  import { ElMessageBox } from "@/components/Vendor/Element";
  import store from "@/store/store";
  import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import DollarWithCircleIcon from "@/components/Icons/DollarWithCircleIcon.vue";
import RoutingIcon from "@/components/Icons/RoutingIcon.vue";
import ClockIcon from "@/components/Icons/ClockIcon.vue";

  export default {
    components: {
      IonToolbar,
      IonButton,
      IonButtons,
      IonIcon,
      IonTitle,
      "modal-user-info": UserInfoModal,
      DollarWithCircleIcon,
      RoutingIcon,
      ClockIcon
    },
    directives: {},
    
    setup() {
      const $store = useStore();
      const $router = useRouter();
      const route = useRoute();
      const dialogVisible = ref(false);
      const currentUrl = process.env.VUE_APP_CURRENT_URL;
      const isAustralia = isAustraliaRegion();

      const setPageClassGlobal = inject("setPageClassGlobal");
      const $modals = inject("$modals");
      const googleMaps = inject(["googleMaps"])
      const message = inject("messages");
  
      let job = ref({});
      console.log("🚀 ~ job:", job)
      let shifts = ref(job.value?.shifts ? job.value?.shifts : {});
        
      const userData = $store.getters.GET_USER_DATA;
      const userRole = userData.role;

      const showJobRateSummary = computed(() => {
        const currentJob = job.value;
        if (!currentJob || !currentJob.id) {
          return false;
        }
        if (currentJob.isInternalStaffOfThisPharmacy || currentJob.isVisibileAsInternalLocum === true) {
          return false;
        }
        if (userRole !== "locum") {
          return true;
        }
        if (currentJob.hideRecommendedRateForLocum === true) {
          return false;
        }
        return locumCanSeeJobRates(currentJob.shifts, userRole);
      });

      const showShiftRateBlock = (shift) => {
        if (shift?.isVisibileAsInternalLocum === true) {
          return false;
        }
        return locumCanSeeShiftRates(shift, userRole);
      };
  
      // shifts.value.forEach((shift) => {
      //   moment().diff(
      //     moment(shift.date + " " + shift.startTime, "YYYY/MM/DD HH:mm:ss"),
      //     "minutes"
      //   ) <= 0
      //     ? (shift.disabled = false)
      //     : (() => {
      //         shift.disabled = true;
      //         shift.checkboxValue = false;
      //       })();
  
      //   if (shift.userId) {
      //     shift.disabled = true;
      //     shift.checkboxValue = false;
      //   }
  
      //   if (shift.abilities) {
      //     const isAssignAvailable = shift.abilities["assign"] == true;
  
      //     shift.disabled = isAssignAvailable ? false : true;
      //     shift.checkboxValue = isAssignAvailable ? true : false;
      //   }
  
      //   if (shift.checkboxValue == undefined) {
      //     shift.checkboxValue = true;
      //   }
      // });
  
      const formsDataArray = {
        dayForm: {
          jobShifts: {
            value: shifts.value,
            errors: null,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  let errors = formsData.dayForm.jobShifts.errors;
                  let formName = formField.formName;
  
                  // console.log(errors);
  
                  if (!errors || !errors.length) {
                    setFormValidation(formName, rule.field, true);
                    callback();
                  } else {
                    setFormValidation(formName, rule.field, false);
                    callback(new Error(""));
                  }
                },
              },
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "jobShiftsBook",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
          },
        },
      };
  
      (async () => {
        try {
          if (!job.value.distance) {
            let needToRetrieveDistance = true;
            let jobsDistancesCache = store.getters.getJobDistancesData.length
              ? store.getters.getJobDistancesData
              : []; // data from cache
  
            for (let cacheItem of jobsDistancesCache) {
              if (cacheItem.id == job.value.pharmacyId && cacheItem.cachedAt) {
                //check if distance exists in cache
                console.log("distance item loaded from cache");
                console.log(cacheItem.distance);
  
                needToRetrieveDistance = false;
                job.value.distance = cacheItem.distance;
                break;
              }
            }
  
            if (needToRetrieveDistance) {
              const result = await googleMaps.getDistance(userData.address, [
                job.value.pharmacy.address,
              ]);
  
              let distance = null;
              let jobDistance = result[0].elements[0].distance
                ? result[0].elements[0].distance.text
                : null;
  
              if (jobDistance) {
                jobDistance = jobDistance.replace(",", ".");
                if (new RegExp("(.*)(km|км)$", "gm").test(jobDistance)) {
                  distance = parseFloat(jobDistance);
                } else if (new RegExp("(.*)(m|м)$", "gm").test(jobDistance)) {
                  distance = parseFloat(jobDistance) / 1000;
                } else {
                  console.log("");
                }
              }
              console.log("----- set distance -----");
              console.log(distance);
  
              job.value.distance = distance;
            }
          }
        } catch (error) {
          console.log(error);
        }
      })();
  
      const checkboxValueChange = () => {
        console.log("hello im clicked");
        if (formsData.dayForm.jobShifts.errors) {
          delete formsData.dayForm.jobShifts.errors;
        }
  
        nextTick(() => {
          checkFormValidation("dayForm", true);
        });
      };
  
      const checkJobDateStart = (dateStart, endDate, trim) => {
        let start = moment(dateStart, "YYYY/MM/DD");
        let end = moment(endDate, "YYYY/MM/DD");
        if (start.format("MMMM") == end.format("MMMM")) {
          if (start.format("D") == end.format("D")) {
            return null;
          }
          return start.format("D ");
        } else {
          return start.format("D " + (trim ? "MMM" : "MMMM"));
        }
      };

      const close=()=>{
        $router.push({
                  name: "search",
                });
      }
      const getSelectedShiftsId = () => {
        return shifts.value
          .filter((day) => {
            if (day.checkboxValue == true) {
              return true;
            }
          })
          .map((day) => day.id);
      };
  
      const userInfoModal = ref({
        name: "userInfo",
        user: {},
      });
  
      const userInfoModalOpen = () => {
        userInfoModal.value.user = job.value.pharmacy;
        $modals.open("userInfoModal");
      };
  
      const goBack = () => {
        goToSearch();
      };
  
      const goToSearch = () =>{
        $router.push({ name: "search" });
      }
  
      const goNext = () => {
        $store.dispatch("setJobDetails", {
          job: job.value,
        });
        $router.push({
          name: "job_book_calendar",
        });
      };


       //job shift apply function
    const applyShift = (formName, jobId) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              await $store.dispatch("APPLY_JOB_SHIFTS_LIST", {
                shift_ids: getSelectedShiftsId(),
                job_id: jobId
              });
              ElMessage({
                type: "success",
                message: "Thank you for applying for the Shift. We will notify you when the shift is offered to you",
              });
              $router.push({
                name: "search",
              });
            } catch (error) {
              let errorMessage = [];
              shifts.value.filter((shift) => {
                let errorsArray = error.errors.some((element) => {
                  if (element.id == shift.id) {
                    errorMessage.push({
                      date: shift.date,
                      message: element.message,
                    });
                    return true;
                  }
                });
                if (!errorsArray) errorMessage.push(null);
              });
              console.log(errorMessage);
              formsData.dayForm.jobShifts.errors = errorMessage;
              checkFormValidation("dayForm", true);
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };
  
      const submit = (formName) => {
        formsRefs[formName].value.validate((valid) => {
          console.log("checking validation", valid);
          if (valid) {
            (async () => {
              try {
                await $store.dispatch("SAVE_JOB_SHIFTS_LIST", {
                  shifts_ids: getSelectedShiftsId(),
                });
                ElMessage({
                  type: "success",
                  message: "Thank You! Your booking has been confirmed.",
                });
                $router.push({
                  name: "search",
                });
                if (!job.value.collaboratedBefore)
                  $router.push({
                    name: "chat_message",
                    params: {
                      chatId: `${job.value.pharmacyId}.${userData.id}`,
                      firstCollaborate: true,
                    },
                  });
              } catch (error) {
                let errorMessage = [];
                shifts.value.filter((shift) => {
                  let errorsArray = error.errors.some((element) => {
                    if (element.id == shift.id) {
                      errorMessage.push({
                        date: shift.date,
                        message: element.message,
                      });
                      return true;
                    }
                  });
                  if (!errorsArray) errorMessage.push(null);
                });
                console.log(errorMessage);
                formsData.dayForm.jobShifts.errors = errorMessage;
                checkFormValidation("dayForm", true);
              }
            })();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      };
      onBeforeMount(async () => {
        console.log("iam urgent from view on beforemount");
        return new Promise((resolve) => {
          $store
            .dispatch("GET_JOB_URGENT_INFO", {
              jobId: route.params.jobId,
              params: {
                with: "shift_availability_stats,pharmacy,pharmacy.settings,pharmacy.address,shifts,shifts.abilities,settings",
              },
            })
            .then((response) => {
              let jobFetchResult = response.data;
              
              console.log("consoleeeeee",jobFetchResult);
              if (jobFetchResult.blacklistedByPharmacy) {
                goToSearch();
              }
              job.value = jobFetchResult;
              job.value.distance = jobFetchResult.distance;
              job.value.applyJob = jobFetchResult.applyJob;
              shifts.value = jobFetchResult.shifts;
              shifts.value.forEach((shift) => {
                moment().diff(
                  moment(
                    shift.date + " " + shift.startTime,
                    "YYYY/MM/DD HH:mm:ss"
                  ),
                  "minutes"
                ) <= 0
                  ? (shift.disabled = false)
                  : (() => {
                      shift.disabled = true;
                      shift.checkboxValue = false;
                    })();
  
                if (shift.userId) {
                  shift.disabled = true;
                  shift.checkboxValue = false;
                }
  
                if (shift.abilities) {
                  const isAssignAvailable = shift.abilities["assign"] == true;
  
                  shift.disabled = isAssignAvailable ? false : true;
                  shift.checkboxValue = isAssignAvailable ? true : false;
                }
  
                if (shift.checkboxValue == undefined) {
                  shift.checkboxValue = true;
                }
              });
              formsData.dayForm.jobShifts.value = shifts.value;
              resolve(response);
            });
        });
      });
      // let jobFetchResult = await $store.dispatch("GET_JOB_INFO", {
      //     jobId: job.value.id,
      //     params: {
      //       with: "shift_availability_stats,pharmacy,pharmacy.settings,pharmacy.address,shifts,shifts.abilities,settings",
      //     }
      // })
      // console.log('FETCH RESULT', jobFetchResult)
      // job.value.distance = jobFetchResult.data.distance
      // shifts.value =  job.value.shifts
      // console.log('JOB', job)
      // console.log('SHIFTS', shifts.value)
  
      onMounted(() => {
        setPageClassGlobal("global_job_book_page");
        setFormRefs();
        checkFormValidation("dayForm", true);
      });
  
      const formatHourlyRate = (regularRate, weekendRate) => {
        let formattedString = "";
  
        formattedString += regularRate ? "$" + regularRate : "";
        formattedString += regularRate && weekendRate ? " - " : "";
        formattedString += weekendRate ? "$" + weekendRate : "";
  
        return formattedString;
      };
  
      const handleChange = (e) => {
        e.stoppropagation();
      };
      const confirmedHours = (confirmedHours, startTime, endTime) => {
        let hours = 0;
        if (confirmedHours == 0 || confirmedHours == null) {
          const start = moment(startTime, "HH:mm:ss");
          const end = moment(endTime, "HH:mm:ss");
  
          hours = timeDiff(start, end);
        } else {
          const string = String(confirmedHours);
          const numHours = string.split(".")[0];
          let minutes = string.split(".")[1];
  
          if (!minutes) {
            const time = numHours + ":" + "00";
            hours = String(time);
          } else {
            minutes = Number.parseFloat(`0.${minutes}`) * 60;
            hours = numHours + ":" + minutes.toFixed(0);
          }
        }
  
        return hours;
      };
      const Sum = (shift) => {
        if (!locumCanSeeShiftRates(shift, userRole)) {
          return "-";
        }
        // function add(accumulator, a) {
        //   // eslint-disable-line no-unused-vars
  
        //   return +accumulator + a;
        // }
  
        let Sum;
        let confirmedHoursVal;
        let payRate;
        let travelCompensation = 0;
        const globalTravelCompensationValue =
          process.env.VUE_APP_TRAVEL_COMPENSATION;
  
        if (userRole === "locum") {
          if (shift.locum == null && shift.payRateExecSuper == null) {
            payRate = shift.recommendedRate;
          } else {
            payRate = shift.payRateExecSuper;
          }
        } else {
          payRate = shift.payRateExecSuper;
        }
  
        if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
          const start = moment(shift.startTime, "HH:mm:ss");
          const end = moment(shift.endTime, "HH:mm:ss");
  
          confirmedHoursVal = timeDiffAsDecimal(start, end);
        } else {
          confirmedHoursVal = shift.confirmedHours;
        }
  
  
        let jobDistance = shift.distance ? shift.distance : null;
  
        if (jobDistance === null && job.value.distance) {
          jobDistance = job.value.distance;
        }
  
        let distance = jobDistance;
  
        
            if (job.value.settings.payingForTravel == 1) {
              if (distance * 2 > 50) {
                travelCompensation =
                  (distance * 2 - 50) * globalTravelCompensationValue;
              } else {
                // travelCompensation = shift.travelCompensation;
                travelCompensation = 0;
              }
            } else if (job.value.settings.payingForTravel == 2) {
              travelCompensation = distance * 2 * globalTravelCompensationValue;
            }
          
  
        // if (!shift.travelCompensation) {
        
        //   if (jobDistance) {
           
  
        //     if (job.value.settings.payingForTravel == 1) {
        //       if (distance * 2 > 50) {
        //         travelCompensation =
        //           (distance * 2 - 50) * globalTravelCompensationValue;
        //       } else {
        //         // travelCompensation = shift.travelCompensation;
        //         travelCompensation = 0;
        //       }
        //     } else if (job.value.settings.payingForTravel == 2) {
        //       travelCompensation = distance * 2 * globalTravelCompensationValue;
        //     }
        //   }
        // } else {
        //   if (job.value.settings.payingForTravel == 1) {
        //   if (distance * 2 > 50) {
        //         travelCompensation =
        //           (distance * 2 - 50) * globalTravelCompensationValue;
        //       } else {
        //         travelCompensation = 0;
        //       }
        //        } else if (job.value.settings.payingForTravel == 2) {
        //       travelCompensation = distance * 2 * globalTravelCompensationValue;
        //     }
        // }
  
        if (!job.value.settings.payingForTravel) {
          travelCompensation = 0;
        }
        Sum = payRate * confirmedHoursVal + travelCompensation;
        if (Sum != 0) {
          Sum = new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(Sum);
        } else {
          Sum = "-";
        }
        return Sum;
      };
  
      const Rate = (shift) => {
        if (!locumCanSeeShiftRates(shift, userRole)) {
          return "-";
        }
        if (userRole === "locum") {
          if (shift.locum == null && shift.payRateExecSuper == null) {
            return Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(shift.recommendedRate);
          } else {
            return Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(shift.payRateExecSuper);
          }
        }
      };
  
      const distance = (job, shift) => {
        let result;
        const globalTravelCompensationValue =
          process.env.VUE_APP_TRAVEL_COMPENSATION;
  
        if (!shift.distance && !job.distance) {
          result = "-";
        } else {
          let distance;
          distance = shift.historyDistance ? shift.historyDistance : job.distance;
          if (job.settings.payingForTravel == 1) {
            if (distance * 2 > 50) {
              const result1 = (distance * 2 - 50) * globalTravelCompensationValue;
              result = new Intl.NumberFormat("en-AU", {
                style: "currency",
                currency: "AUD",
              }).format(result1);
            } else {
              result = "-";
            }
          } else if (job.settings.payingForTravel == 2) {
            result = new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(distance * 2 * globalTravelCompensationValue);
          }
        }
  
        return result;
      };
      const share = () => {
        const link = currentUrl + "job-preview/" + job.value.id;
        const el = document.createElement("textarea");
        el.value = link;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        ElMessageBox.alert("Link to current job copied to clipboard", "Thanks", {
          type: "success",
          showCancelButton: false,
          confirmButtonText: "Close",
          callback: () => {
            console.log("btn click");
          },
        });
      };
      const showShiftInformation = (shift) => {
        if (!shift.userId) return true;
        if (shift.userId === userData.id) return true;
        return false;
      };
  
      const travelCompensationCount = (job, shift) => {
        if (
          job.settings.payingForTravel === 0 &&
          !shift.adminTravelCompensation
        ) {
          return "-";
        }
        if (job.settings.payingForTravel === 0 && shift.adminTravelCompensation) {
          return `$${shift.adminTravelCompensation}`;
        } else {
          return distance(job, shift);
        }
      };
      const {
        checkFormValidation,
        setFormValidation,
        setFormRefs,
        formsData,
        formsRefs,
      } = formHooks(formsDataArray);
  
      return {
        travelCompensationCount,
        showShiftInformation,
        formatHourlyRate,
        showJobRateSummary,
        showShiftRateBlock,
        formsData,
        handleChange,
        checkFormValidation,
        setFormValidation,
        goBack,
        goNext,
        submit,
        job,
        shifts,
        checkJobDateStart,
        checkboxValueChange,
        userInfoModalOpen,
        userInfoModal,
        Sum,
        confirmedHours,
        Rate,
        distance,
        share,
        dialogVisible,
        close,
        isAustralia,
        message,
        applyShift
      };
    },
  };
  </script>
  